import React from 'react';

const TermPrivacy = () => {
    return (
        <div>
            <h2>Term&Privacy</h2>
        </div>
    );
};

export default TermPrivacy;